import React from "react";
import { Layout, Spin } from "antd";
import { useLocation } from "react-router-dom";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { LoadingOutlined } from "@ant-design/icons";
import "./captcha.scss";
import { DashboardFilterProvider } from "../../modules/Dashboards/hooks/DashboardFilterProvider";

const { Content } = Layout;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const DashboardLayout = (props) => {
  
  const location = useLocation();
  const isDashboardRoute = location.pathname.includes("dashboard");

  return (
    <DashboardFilterProvider>
      <Layout className="main-layout">
        <Header />
        <Layout>
          <Sidebar />
          <Layout className="layout-space">
            <Spin
              spinning={props.load || false}
              indicator={antIcon}
              style={{ position: "fixed" }}
            >
              <Content
                className={
                  !isDashboardRoute ? `main-content ${props.className}` : ""
                }
              >
                {props.children}
              </Content>
            </Spin>
          </Layout>
        </Layout>
      </Layout>
    </DashboardFilterProvider>
  );
};

export default DashboardLayout;
